var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
import { getDiagramState } from './helpers';
import { syncActiveDiagramTheme, runWithDiagramTheme } from './theme';
import { resolveEffectiveUiTokens } from '../components/nodeTheme';
/** Attach rebuild so theme changes can recreate diagram chrome without losing JSON state. */
export function installDiagramRebuild(group, app, factory) {
    var rebuild = function () {
        var props = __assign(__assign({}, getDiagramState(group)), { x: group.x, y: group.y });
        var theme = syncActiveDiagramTheme(resolveEffectiveUiTokens(app, props), app);
        runWithDiagramTheme(theme, function () {
            var e_1, _a, e_2, _b;
            try {
                for (var _c = __values(__spreadArray([], __read(group.children), false)), _d = _c.next(); !_d.done; _d = _c.next()) {
                    var child = _d.value;
                    group.remove(child);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
                }
                finally { if (e_1) throw e_1.error; }
            }
            var fresh = factory(props, app);
            try {
                for (var _e = __values(__spreadArray([], __read(fresh.children), false)), _f = _e.next(); !_f.done; _f = _e.next()) {
                    var child = _f.value;
                    fresh.remove(child);
                    group.add(child);
                }
            }
            catch (e_2_1) { e_2 = { error: e_2_1 }; }
            finally {
                try {
                    if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                }
                finally { if (e_2) throw e_2.error; }
            }
            group.metadata.diagramState = fresh.metadata.diagramState;
        });
        app.requestRender();
    };
    group.metadata.diagramRebuild = rebuild;
}
/** Rebuild every diagram root that exposes `diagramRebuild` (per-node uiTheme applied inside). */
export function refreshDiagram(root, _app) {
    var walk = function (n) {
        var e_3, _a;
        var _b, _c;
        var rebuild = (_b = n.metadata) === null || _b === void 0 ? void 0 : _b.diagramRebuild;
        if (typeof rebuild === 'function' && ((_c = n.metadata) === null || _c === void 0 ? void 0 : _c.diagramType)) {
            rebuild();
        }
        if ('children' in n) {
            try {
                for (var _d = __values(n.children), _e = _d.next(); !_e.done; _e = _d.next()) {
                    var child = _e.value;
                    walk(child);
                }
            }
            catch (e_3_1) { e_3 = { error: e_3_1 }; }
            finally {
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                }
                finally { if (e_3) throw e_3.error; }
            }
        }
    };
    walk(root);
}
